import { IAuthServiceClass } from "../../types/IAuthServiceClass";
import { IAuthToken } from "../../types/IAuthToken";
import { ITokenRequestBody } from "../../types/ITokenRequestBody";
import { generateCodeChallenge, generateRandomString } from './pkce';
import { toUrlEncoded } from "./utils";


export class AuthServiceClass {
    props: IAuthServiceClass;

    constructor(props: IAuthServiceClass) {
        this.props = props;
    }

    getCookie = (name: string): string | undefined => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop()?.split(';').shift();
    }
   
    authorize = async (): Promise<boolean> => {

        const codeVerifier = generateRandomString(96);

        window.localStorage.setItem('codeVerifier', codeVerifier);

        const codeChallenge = await generateCodeChallenge(codeVerifier);

        window.localStorage.setItem('codeChallenge', codeChallenge);

        const {
            clientId,
            provider,
            strLocation,
            scopes,
        } = this.props;

        const authorizeEndpoint = "";

        const query = {
            clientId,
            scope: scopes.join(" "),
            responseType: "code",
            redirectUri: strLocation,
            codeChallenge,
            codeChallengeMethod: "S256",
        }

        const url = `${authorizeEndpoint || `${provider}/authorize`}?${toUrlEncoded(
            query
        )}`;

        window.location.replace(url);
        
        return true;
    }

    getCodeVerifier = ():any => {
        const rawCV = window.localStorage.getItem("codeVerifier");

        if (null === rawCV) {
            throw new Error("PKCE pair not found in local storage");
        } else {
            return rawCV;
        }
    }

    fetchToken = async (code: string): Promise<IAuthToken> => {
        const {
            clientId,
            clientSecret,
            provider,
            strLocation,
            redirectUri,
            scopes,
        } = this.props;

        const grantType = "authorization_code";

        let payload: ITokenRequestBody = {
            clientId,
            ...(clientSecret ? { clientSecret } : {}),
            redirectUri,
            grantType,
        };

        const codeVerifier = this.getCodeVerifier();

        payload = {
            ...payload,
            code,
            codeVerifier
        }

        const response = await fetch(`${provider}/token`, {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            method: "POST",
            body: toUrlEncoded(payload),
        });

        let json = await response.json();
        this.setAuthTokens(json as IAuthToken);

        const t = this.getAuthTokens();

        return t;
    }

    setAuthTokens(auth: IAuthToken): void {
        const refreshSlack = 5;
        const now = new Date().getTime();
        auth.expires_at = now + (auth.expires_in + refreshSlack) * 1000;
        window.localStorage.setItem("auth", JSON.stringify(auth));
    }

    getAuthTokens(): IAuthToken {
        return JSON.parse(window.localStorage.getItem("auth") || "{}");
    }

    getCodeFromLocation(location: Location): string | null {
        const split = location.toString().split("?");
        if (split.length < 2) {
            return null;
        }
        const pairs = split[1].split("&");
        for (const pair of pairs) {
            const [key, value] = pair.split("=");
            if (key === "code") {
                return decodeURIComponent(value || "");
            }
        }
        return null;
    }
    
}